<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('setting') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab>{{ $t('general') }}</v-tab>
        <v-tab>{{ $t('accounting') }}</v-tab>
        <v-tab>{{ $t('InvoicePrint') }}</v-tab>
        <v-tab :disabled="($store.state.gateway == 'active' ? false : true)">
          {{ $t('paymentSetting') }}
        </v-tab>

        <v-tab-item>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="1"
              >
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <file-picker
                      ref="refFilePicker"
                      v-model="imagePicker"
                      :label="$t('logo')"
                      :avatar="true"
                      :multiple="false"
                      extensions="image/png, image/gif, image/jpeg"
                      type-prop="logo"
                      :val="(imagePickerVal ? imagePickerVal : null)"
                    />
                  </v-col>
                  <v-col />
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="11"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="abrName"
                      :label="$t('abrName')"
                      :rules="[v => !!v || $t('is-required')]"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <autocomplete
                      v-model="bussiness"
                      :title="$t('businessType')"
                      type="business"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="nationalCode"
                      :label="$t('national-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="email"
                      :label="$t('email')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="mobile"
                      :label="$t('mobile')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="phone"
                      :label="$t('phone')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="address"
                      outlined
                      clearable
                      dense
                      :label="$t('address')"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon>
                          mdi-map-marker
                        </v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="postalCode"
                      :label="$t('postal-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="financialCode"
                      :label="$t('financial-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="commissionDetail"
                      :title="$t('commissionDetail')"
                      type="alldetail"
                      :value="commissionDetail"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="shippingDetail"
                      :title="$t('shippingDetail')"
                      type="alldetail"
                      :value="shippingDetail"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="processingDetail"
                      :title="$t('processingDetail')"
                      type="alldetail"
                      :value="processingDetail"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="penaltyCancellingDetail"
                      :title="$t('penaltyCancellingDetail')"
                      type="alldetail"
                      :value="penaltyCancellingDetail"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="negativeInventory"
                      class="mt-0"
                      :label="$t('negativeInventory')"
                      value="yes"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="showPurchasePriceInSell"
                      class="mt-0"
                      :label="$t('showPurchasePriceInSell')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="showCodeProductInName"
                      class="mt-0"
                      :label="$t('showCodeProductInName')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="preventDuplicateMobile"
                      class="mt-0"
                      :label="$t('preventDuplicateMobile')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="preventDuplicateNationalCode"
                      class="mt-0"
                      :label="$t('preventDuplicateNationalCode')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="happyBirthdaySMS"
                      class="mt-0"
                      :label="$t('happyBirthdaySMS')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="usersWelcomeSMS"
                      class="mt-0"
                      :label="$t('usersWelcomeSMS')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchInvoice"
                      class="mt-0"
                      :label="$t('limitBranchInvoice')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchUser"
                      class="mt-0"
                      :label="$t('limitBranchUser')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchProduct"
                      class="mt-0"
                      :label="$t('limitBranchProduct')"
                      value="active"
                    />
                  </v-col>
<!--                  <v-col-->
<!--                    cols="12"-->
<!--                    md="3"-->
<!--                  >-->
<!--                    <v-checkbox-->
<!--                      v-model="limitBranchBank"-->
<!--                      class="mt-0"-->
<!--                      :label="$t('limitBranchBank')"-->
<!--                      value="active"-->
<!--                    />-->
<!--                  </v-col>-->
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchPayment"
                      class="mt-0"
                      :label="$t('limitBranchPayment')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchCheck"
                      class="mt-0"
                      :label="$t('limitBranchCheck')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchCost"
                      class="mt-0"
                      :label="$t('limitBranchCost')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchDocument"
                      class="mt-0"
                      :label="$t('limitBranchDocument')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="limitBranchEntrepot"
                      class="mt-0"
                      :label="$t('limitBranchEntrepot')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="branchValidStore"
                      class="mt-0"
                      :label="$t('branchValidStore')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="autoPrintInvoiceInOtherAccounts"
                      class="mt-0"
                      :label="$t('autoPrintInvoiceInOtherAccounts')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="defaultCustomer"
                      :title="$t('defaultCustomer')"
                      type="person"
                      :value="defaultCustomer"
                    />
                  </v-col>
                  <v-col
                    v-if="$store.state.allConfig && $store.state.allConfig.goldSystem && $store.state.allConfig.goldSystem === 'active'"
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="getGolePriceAuto"
                      class="mt-0"
                      :label="$t('getGolePriceAuto')"
                      value="active"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="reservedInvoice"
                      class="mt-0"
                      :label="$t('reservedInvoice')"
                      value="active"
                    />
                  </v-col>
                  <!--                  <v-col-->
                  <!--                    class="mb-0 pb-0 "-->
                  <!--                    cols="12"-->
                  <!--                    md="6"-->
                  <!--                  >-->
                  <!--                    <aicomplete-->
                  <!--                      v-model="productGroup"-->
                  <!--                      :val="productGroup"-->
                  <!--                      title="productGroupShowInvoice"-->
                  <!--                      :multiple="true"-->
                  <!--                      type="productGroup"-->
                  <!--                      :data="JSON.stringify({parent:0,type:'group'})"-->
                  <!--                      :new-btn="true"-->
                  <!--                    />-->
                  <!--                  </v-col>-->
                </v-row>
                <v-row
                  v-show="this.$store.state.allConfig && this.$store.state.allConfig.investorSystem === 'active'"
                  class="mx-0"
                >
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <autocomplete
                      v-model="brokerAccount"
                      :title="$t('brokerAccount')"
                      type="person"
                      :value="brokerAccount"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="brokerPercent"
                      :label="$t('brokerPercent')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-row class="ma-0">
                <v-col
                  cols="6"
                  class="px-1"
                >
                  <v-btn
                    color="primary"
                    class="mr-0"
                    :loading="isLoading"
                    @click="update"
                  >
                    {{ $t('submit') }}
                  </v-btn>
                </v-col>
                <v-col
                  cols="6"
                  class="px-2"
                >
                  <v-btn
                    color="grey"
                    outlined
                    class="float-left"
                    @click="$emit('close')"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-container>
        </v-tab-item>
        <v-tab-item style="height: auto">
          <accounting />
        </v-tab-item>
        <v-tab-item style="height: auto">
          <invoiceprint />
        </v-tab-item>
        <v-tab-item>
          <v-tabs
            vertical
          >
            <v-tab>{{ $t('pos') }}</v-tab>
            <v-tab>{{ $t('zibal') }}</v-tab>
            <v-tab>{{ $t('zarinpal') }}</v-tab>
            <v-tab-item>
              <pos />
            </v-tab-item>
            <v-tab-item>
              <zibal />
            </v-tab-item>
            <v-tab-item>
              <zarinpal />
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
      </v-tabs>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Accounting from './partial/accounting'
import pos from './partial/pos.vue'
import Zarinpal from './partial/zarinpal'
import zibal from './partial/zibalPayment'
import Invoiceprint from './partial/invoicePrint'
import autocomplete from '../../components/general/patial/autocompletei'
import General from '../../../../Mixins/general'
import filePicker from '../../components/general/filePicker/index'
export default {
  name: 'Customer',
  components: {
    pos,
    Accounting,
    Invoiceprint,
    zibal,
    Zarinpal,
    filePicker,
    autocomplete
  },
  mixins: [General],
  data: () => ({
    valid: true,
    preventDuplicateMobile: null,
    reservedInvoice: null,
    getGolePriceAuto: null,
    imagePicker: null,
    imagePickerVal: null,
    showPurchasePriceInSell: null,
    logo: null,
    bussiness: null,
    productGroup: null,
    brokerAccount: null,
    defaultCustomer: null,
    brokerPercent: null,
    happyBirthdaySMS: null,
    usersWelcomeSMS: null,
    preventDuplicateNationalCode: null,
    showCodeProductInName: null,
    limitBranchInvoice: 'active',
    limitBranchUser: 'active',
    limitBranchProduct: 'active',
    limitBranchCheck: 'active',
    limitBranchBank: 'active',
    limitBranchCost: 'active',
    limitBranchPayment: 'active',
    limitBranchDocument: 'active',
    limitBranchEntrepot: 'active',
    branchValidStore: null,
    commissionDetail: null,
    shippingDetail: null,
    penaltyCancellingDetail: null,
    processingDetail: null,
    autoPrintInvoiceInOtherAccounts: null,
    type: null,
    abrName: null,
    mobile: null,
    nationalCode: null,
    postalCode: null,
    businessName: null,
    financialCode: null,
    phone: null,
    render: false,
    isLoading: false,
    email: null,
    address: null,
    negativeInventory: null
  }),
  watch: {
  },
  activated () {
    this.show()
  },
  beforeMount () {
    this.show()
  },
  mounted () {
  },
  methods: {
    update () {
      var app = this
      app.isLoading = true
      app.$axios.put(this.$endpoint + 'setting/' + 0, this.$data)
        .then(res => {
          res = res.data
          if (app.imagePicker) {
            app.$refs.refFilePicker.create(1)
          }
          app.snakbarText = app.$t('registered')
          app.snakbarColor = 'green'
          app.snakbar = true
          var storage = JSON.parse(localStorage.getItem('token'))
          storage.init.negative_inventory = res.data.negetivInventory
          localStorage.setItem('token', JSON.stringify(storage))
          app.$store.commit('SET_NEGATIVE_INVENTORY', res.data.negetivInventory.value)
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.isLoading = false))
    },
    show () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
        params: {
        }
      })
        .then(res => {
          app.$nextTick(() => {
            res = res.data
            app.id = res.id
            app.abrName = res.abrName
            app.financialCode = res.financialCode
            app.city = res.city
            app.imagePickerVal = res.logo
            app.showPurchasePriceInSell = res.showPurchasePriceInSell
            app.getGolePriceAuto = res.getGolePriceAuto
            app.imagePicker = res.logo
            app.bussiness = res.bussiness
            app.preventDuplicateMobile = res.preventDuplicateMobile
            app.preventDuplicateNationalCode = res.preventDuplicateNationalCode
            app.happyBirthdaySMS = res.happyBirthdaySMS
            app.usersWelcomeSMS = res.usersWelcomeSMS
            app.reservedInvoice = res.reservedInvoice
            app.showCodeProductInName = res.showCodeProductInName
            app.autoPrintInvoiceInOtherAccounts = res.autoPrintInvoiceInOtherAccounts
            app.limitBranchPayment = res.limitBranchPayment
            app.limitBranchBank = res.limitBranchBank
            app.limitBranchDocument = res.limitBranchDocument
            app.limitBranchInvoice = res.limitBranchInvoice
            app.limitBranchProduct = res.limitBranchProduct
            app.limitBranchUser = res.limitBranchUser
            app.limitBranchCost = res.limitBranchCost
            app.limitBranchCheck = res.limitBranchCheck
            app.limitBranchEntrepot = res.limitBranchEntrepot
            app.branchValidStore = res.branchValidStore
            app.penaltyCancellingDetail = res.penaltyCancellingDetail
            app.commissionDetail = res.commissionDetail
            app.processingDetail = res.processingDetail
            app.defaultCustomer = res.defaultCustomer
            app.shippingDetail = res.shippingDetail
            app.productGroup = res.productGroup
            app.email = res.email
            app.phone = res.phone
            app.mobile = res.mobile
            app.address = res.address
            app.nationalCode = res.nationalCode
            app.financialCode = res.financialCode
            app.postalCode = res.postalCode
            app.brokerAccount = res.brokerAccount
            app.brokerPercent = res.brokerPercent
            app.negativeInventory = res.negative_inventory
            app.render = true
          })
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
